import { Injectable } from '@angular/core';
import { Toaster,  } from 'ngx-toast-notifications';
import { NotificationConfig } from './model/notification-config';
@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  constructor(
    private toaster: Toaster
  ) { }

  open(text: string | string[], config: NotificationConfig) {
    if (text instanceof Array) {
      text.forEach(item => this.toaster.open(item, config));
    } else {
      this.toaster.open(text, config);
    }
  }
}
